import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";

const ranking = [...movies].sort((a, b) => b.views - a.views).slice(0, 6);
const maxViews = ranking[0].views;

const quotes = [
  { movieId: "12", text: "构图太讲究了，每一帧都能截图当海报。", user: "第三面镜子" },
  { movieId: "16", text: "不是不爱了，是各自长大了一点点。这句话我记很久。", user: "四季" },
  { movieId: "9", text: "几乎没有血腥，但心理压力拉满，这才是本事。", user: "红鞋" },
];

export default function RankingSection() {
  return (
    <section className="w-full border-y border-background-200/60 bg-background-100/40">
      <div className="mx-auto w-full max-w-[1360px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-7">
            <div className="flex items-end justify-between">
              <div>
                <div className="flex items-center gap-2">
                  <span className="h-3 w-[3px] rounded-full bg-accent-500"></span>
                  <span className="font-label text-[11px] uppercase tracking-[0.28em] text-accent-500">
                    Weekly ranking
                  </span>
                </div>
                <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  本周热度榜
                </h2>
              </div>
              <Link
                to="/category?c=hot"
                className="group inline-flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-accent-400"
              >
                完整榜单
                <i className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-0.5"></i>
              </Link>
            </div>

            <div className="mt-5 overflow-hidden rounded-lg border border-background-200/80 bg-background-50">
              {ranking.map((movie, index) => (
                <Link
                  key={movie.id}
                  to={`/detail/${movie.id}`}
                  className="group flex items-center gap-3 border-b border-background-200/60 px-3 py-3 transition-colors last:border-b-0 hover:bg-background-100 md:gap-4 md:px-4"
                >
                  <span
                    className={`w-6 shrink-0 text-center font-display text-lg font-semibold ${
                      index < 3 ? "text-accent-500" : "text-foreground-500"
                    }`}
                  >
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <div className="h-16 w-11 shrink-0 overflow-hidden rounded bg-background-200 md:h-[72px] md:w-12">
                    <img
                      src={movie.poster}
                      alt={`${movie.title} 电影海报缩略图`}
                      title={`${movie.title} 影片资料`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center justify-between gap-2">
                      <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-accent-400">
                        {movie.title}
                      </h3>
                      <span className="flex shrink-0 items-center gap-1 text-[11px] text-foreground-500">
                        <i className="ri-eye-line"></i>
                        {(movie.views / 1000).toFixed(1)}k
                      </span>
                    </div>
                    <p className="mt-1 truncate text-[11px] text-foreground-500">
                      {movie.year} · {movie.genres.join(" / ")} · {movie.director}
                    </p>
                    <div className="mt-2 h-1 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-primary-600 to-accent-500"
                        style={{ width: `${Math.max(12, (movie.views / maxViews) * 100)}%` }}
                      ></div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="flex items-end justify-between">
              <div>
                <div className="flex items-center gap-2">
                  <span className="h-3 w-[3px] rounded-full bg-accent-500"></span>
                  <span className="font-label text-[11px] uppercase tracking-[0.28em] text-accent-500">
                    Reader notes
                  </span>
                </div>
                <h2 className="mt-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  读者短评摘录
                </h2>
              </div>
            </div>

            <div className="mt-5 space-y-3">
              {quotes.map((quote) => {
                const target = movies.find((movie) => movie.id === quote.movieId);
                if (!target) return null;
                return (
                  <div
                    key={quote.movieId}
                    className="rounded-lg border border-background-200/80 bg-background-50 p-4"
                  >
                    <i className="ri-double-quotes-l text-lg text-primary-400"></i>
                    <p className="mt-1 text-sm leading-6 text-foreground-700">{quote.text}</p>
                    <div className="mt-3 flex items-center justify-between border-t border-background-200/60 pt-3">
                      <span className="text-xs text-foreground-500">— {quote.user}</span>
                      <Link
                        to={`/detail/${target.id}`}
                        className="whitespace-nowrap text-xs text-accent-400 transition-colors hover:text-accent-300"
                      >
                        《{target.title}》
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="mt-4 rounded-lg border border-primary-800/60 bg-primary-950/60 p-4">
              <div className="flex items-start gap-3">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-500/20 text-accent-400">
                  <i className="ri-information-line"></i>
                </span>
                <p className="text-xs leading-6 text-primary-100/80">
                  榜单依据站内浏览量排序，每周更新一次。评论摘录来自读者公开留言，仅展示观点，不代表本站立场。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}